import {RouteComponentProps, withRouter} from "react-router";
import * as React from "react";
import Routes from "../../../navigation/route/Route";
import CreateUserForm from "../../user/form/create/CreateUserForm";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";

type Props = RouteComponentProps<any>;

class OrganisationUserCreate extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create User"}/>
				<PageContentView>
					<CreateUserForm onSuccess={this.onSuccess} onCancel={this.onCancel}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added User
	 */
	private onSuccess() {
		this.props.history.push(Routes.OrganisationUserList);
	}

	/**
	 * On cancel click.
	 * Redirect to previous page.
	 */
	private onCancel() {
		this.props.history.goBack();
	}
}

export default withRouter(OrganisationUserCreate);